import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonDirective } from "@ankaadia/ankaadia-shared-frontend";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { PrimeTemplate } from "primeng-v17/api";
import { ChipModule } from "primeng-v17/chip";
import { EditorModule } from "primeng-v17/editor";
import { MultiSelectModule } from "primeng-v17/multiselect";
import { OverlayPanelModule } from "primeng-v17/overlaypanel";
import { TooltipModule } from "primeng-v17/tooltip";
import { AppendToBodyDirective } from "../../shared/primeng/append-to-body/append-to-body.directive";
import { MultiSelectEditableColumnAutoFocusDirective } from "../../shared/primeng/multi-select-editable-column-auto-focus/multi-select-editable-column-auto-focus.directive";
import { MultiSelectReadonlyFixDirective } from "../../shared/primeng/multi-select-readonly-fix/multi-select-readonly-fix.directive";
import { MultiSelectSelectedItemsLabelDirective } from "../../shared/primeng/multi-select-selectedItemsLabel/multi-select-selectedItemsLabel.directive";
import { MultiSelectSortSelectedValuesOnTopDirective } from "../../shared/primeng/multi-select-sort-selected-values-on-top/multi-select-empty.directive";
import { StaticDataPipe } from "../../shared/static-data/static-data.pipe";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiFormlyChipsComponent } from "./new-ui-formly-chips.component";

@Component({
  selector: "app-chips",
  templateUrl: "./chips.component.html",
  imports: [
    TranslateDirective,
    NgFor,
    ChipModule,
    NgIf,
    ButtonDirective,
    OverlayPanelModule,
    AppendToBodyDirective,
    MultiSelectModule,
    MultiSelectEditableColumnAutoFocusDirective,
    MultiSelectReadonlyFixDirective,
    MultiSelectSelectedItemsLabelDirective,
    MultiSelectSortSelectedValuesOnTopDirective,
    FormsModule,
    TooltipModule,
    EditorModule,
    PrimeTemplate,
    AsyncPipe,
    StaticDataPipe,
    FormlySelectModule,
  ],
})
export class FormlyChipsComponent extends NewUiFormlyChipsComponent {}
